<template>
  <div id="award">
    <nav-common></nav-common>
    <div class="award-content">
      <el-card class="box-card">
          <ul>
              <li v-for="item of reward.data" class="tect item">
                  <router-link :to="{name:'NoticeItem',query:{id: item.id,type: 'award'}}">
                      <div class="title" v-text="item.title"></div>
                      <div class="date" v-text="item.created_at"></div>
                  </router-link>
              </li>
          </ul>
          <el-pagination
              background
              layout="prev, pager, next"
              @current-change="getreward"
              :current-page="reward.current_page"
              :total="reward.total">
          </el-pagination>
      </el-card>
    </div>
  </div>
</template>
<script>
    import Vue from 'Vue';
    import NavCommon from '@/components/navtop/navcommon'
    export default{
        name: 'Award',
        data() {
            return {
                reward: {}
            }
        },
        created() {
            this.getreward();
        },
        methods: {
            getreward(page) {
                var _this = this;
                _this.$http({
                    method: 'get',
                    url: _this.$api + '/service/agent/reward/lists?page=' + page
                }).then((res) => {
                    if(res.data.code == 200) {
                        _this.reward = res.data.data;
                    }
                })
            }
        },
        components: {
          NavCommon
        }
    }
</script>
<style lang="stylus" scoped>
  .award-content
    position relative
    margin 20px
    padding 60px 40px 20px 40px
    background #f8f8f8
    box-shadow 3px 3px 3px #f5f5f5 inset
    .item
        width 750px
        a
            display flex
            height 40px
            line-height 40px
            padding 0 10px
            margin-bottom 5px
            border 1px solid #dcdfe6
            border-radius 5px
            &:hover
                border-color #3f9eff
                color #000
            .title
                flex 0 0 500px
            .date
                flex 1
                text-align right
</style>




// WEBPACK FOOTER //
// src/components/award/award.vue